import LoanInitiationScreen from './LoanInitiationScreen';

export default LoanInitiationScreen;
